import { getOauthPortalPickerForUserRpc } from 'apps-service-types/ApplicationsHubletsService/operations';
import { registerQuery, useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { rpcNoPortalClient } from '../../../data/api/rpcClients';
import { queryResultToRequestStatus } from '../../../utils/dataFetchingClientUtils';
import { isValidClientId } from '../../../utils/authUtils';
import { getEarlyRequestOrFetch } from '../../../earlyRequests/getEarlyRequestOrFetch';
import { EarlyRequestKeys } from '../../../earlyRequests/earlyRequestKeys';
const fetchPortalPickerAccountsApi = clientId => {
  return getEarlyRequestOrFetch(EarlyRequestKeys.ACCOUNTS_LIST, () => rpcNoPortalClient.call(getOauthPortalPickerForUserRpc, {
    pathParameters: {
      clientId
    }
  }));
};
const FETCH_ACCOUNTS_QUERY = registerQuery({
  fieldName: 'portalPickerAccounts',
  args: ['clientId'],
  fetcher: ({
    clientId
  }) => fetchPortalPickerAccountsApi(clientId).then(response => {
    // Sort so that any disabled accounts are at the bottom of the list
    const sortedAccounts = [...response.accounts].sort((a, b) => {
      if (a.disabled === b.disabled) {
        return 0;
      }
      return a.disabled ? 1 : -1;
    });
    return sortedAccounts;
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        message: 'There was a problem fetching the portalpicker accounts',
        clientId
      }
    });
    throw error;
  })
});
export const useFetchAccounts = clientId => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_ACCOUNTS_QUERY, {
    variables: {
      clientId
    },
    skip: !isValidClientId(clientId)
  });
  return {
    data: data === null || data === void 0 ? void 0 : data.portalPickerAccounts,
    loading,
    error,
    requestStatus: queryResultToRequestStatus({
      hasData: !!data,
      loading,
      error
    })
  };
};